module.exports = __webpack_public_path__ + "static/media/chorthippus_pullus_Balz_005_APA.48295dd6.png";